import getDFPBlock from "../../utils/getDFPBlock";

export default function (newsId){
    let summary = document.querySelector('#newsBodyWrap-' + newsId + ' > .article_text > #newsSummary');
    if(summary !== null) {
        let newsMiddleNode = summary.childNodes[Math.floor(summary.childNodes.length / 2) + 1];
        let advPlace = document.createElement('div');
        advPlace.id = 'adv' + newsId;
        advPlace.style.minHeight = '300px';

        if (document.getElementById(advPlace.id) !== null) {
            return;
        }

        newsMiddleNode.after(advPlace);

        if (window.innerWidth < 640) {
            getDFPBlock('/56301415/24tv_fun_300x250_mobile', [300, 250], advPlace.id, '300px');
        } else {
            getDFPBlock('/56301415/24tv_fun_600x300_desktop', [600, 300], advPlace.id, '600px');
        }
    }
}